import React, { useEffect } from 'react'
import { TranslateContextProvider } from 'client/common/translator'
import { dispatchPageBusEvent } from 'client/common/pageBus'
import { LAST_VIEWED_PRODUCTS_RENDERED } from 'client/pageBusEvents'
import { useCookies } from 'react-cookie'
import { useFetchLastViewedData } from 'client/fragments/lastViewedProducts/hooks/useFetchLastViewedData'
import { useLastViewedAnalytic } from 'client/fragments/lastViewedProducts/hooks/useLastViewedAnalytic'
import { useAppearedInViewById } from 'client/common/hooks/useInview'
import { View } from 'client/fragments/lastViewedProducts/components/view/View'
import { ChakraProvider } from '@chakra-ui/react'
import { chemistryTheme, Container, DESKTOP } from 'chemistry'

const VIEWED_PRODUCTS_COOKIE = 'viewed-products'

const Component = props => {
  const nodeId =
    typeof document !== 'undefined' && document.getElementById('lastViewedProductsContainer')
      ? 'lastViewedProductsContainer'
      : 'lastViewedProducts'
  const inView = useAppearedInViewById(nodeId)
  const isContainerless = nodeId === 'lastViewedProducts'

  if (!inView && !isContainerless) return null

  return <LastViewedProducts {...props} inView={inView} isContainerless={isContainerless} />
}

const LastViewedProducts = props => {
  const [cookies] = useCookies([VIEWED_PRODUCTS_COOKIE]) // dependencies specifies when will be triggered
  const productCodes = cookies[VIEWED_PRODUCTS_COOKIE]

  if (!productCodes) return null

  return <InViewComponent {...{ ...props, inView: true, productCodes }} />
}

const InViewComponent = props => {
  const { inView, productCodes } = props
  const { data, error, loading } = useFetchLastViewedData(props, inView, productCodes)

  const onProductClick = useLastViewedAnalytic(data)

  useEffect(() => {
    dispatchPageBusEvent({ type: LAST_VIEWED_PRODUCTS_RENDERED })
  }, [])

  const titleKey = 'lister.products.last_viewed_title'
  const rootClassName = 'mxd-container-gutterless'

  return (
    <ChakraProvider resetCSS={false} theme={chemistryTheme}>
      <TranslateContextProvider translations={props.translations}>
        <Container
          wrapper={{
            padding: '0 1rem',
            sx: { [DESKTOP]: { padding: 0 } }
          }}
          sx={{ paddingInline: 0, [DESKTOP]: { margin: '0 auto', width: '100%' } }}
        >
          <View {...{ ...props, data, error, loading, titleKey, rootClassName, onProductClick }} />
        </Container>
      </TranslateContextProvider>
    </ChakraProvider>
  )
}

export default { Component }
